module.exports = __webpack_public_path__ + "img/schedule_page1.960fc5ee.jpg";